import Icon from './Icon';

/**
 * The glyphs that operate a PICTURE rather than the app.
 *
 * `ControlIcons.js` said this file would exist: every pictogram in that one
 * steps the deck, opens the filters or sends a card somewhere, and it named the
 * arrival of a second family as the moment to split. These two are that family.
 * Nothing here operates the product — they move the reader inside one photograph
 * and back out of it, which is why they are only ever drawn by the full-screen
 * viewer (SPEC-012).
 *
 * Same frame, same 1.75px stroke, same mitred joins as every other glyph: the
 * seam is what a glyph MEANS, not how it is drawn.
 */

/**
 * Getting closer to a picture — the pinch's single-pointer equivalent, and the
 * only VISIBLE thing on the viewer that says the screen zooms at all.
 *
 * A loupe with a plus in it. Deliberately not a pair of arrows pointing outward:
 * that glyph means "make this bigger" of a window, and what this does is move
 * the reader into a picture that does not change size.
 */
export function ZoomInIcon(props) {
    return (
        <Icon {...props}>
            <circle cx="10.5" cy="10.5" r="6" />
            <path d="M8 10.5h5M10.5 8v5" />
            <path d="m15 15 4.5 4.5" />
        </Icon>
    );
}

/**
 * The same control once the reader is inside the picture: back to the whole of
 * it.
 *
 * Four corners rather than the loupe with a minus, because this is not the
 * opposite of a zoom by one step — it is a jump all the way out, and a minus
 * would promise the step. The corners are the frame the picture returns to.
 */
export function FitScreenIcon(props) {
    return (
        <Icon {...props}>
            <path d="M4.5 9V4.5H9" />
            <path d="M15 4.5h4.5V9" />
            <path d="M19.5 15v4.5H15" />
            <path d="M9 19.5H4.5V15" />
        </Icon>
    );
}
